import React from 'react'
import { Paper, Typography, Button } from '@mui/material'

class AnalyzerErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Analyzer Error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Paper sx={{ p: 3, textAlign: 'center', mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Something went wrong with the analysis.
          </Typography>
          <Button 
            variant="contained" 
            onClick={() => window.location.reload()}
          >
            Try Again
          </Button>
        </Paper>
      )
    }

    return this.props.children
  }
}

export default AnalyzerErrorBoundary